<template>
<div>
    <div id="nav-years">
      <router-link to="/year/2001">2001</router-link>
      <router-link to="/year/2002">2002</router-link>
      <router-link to="/year/2003">2003</router-link>
      <router-link to="/year/2004">2004</router-link>
      <router-link to="/year/2005">2005</router-link>
      <router-link to="/year/2006">2006</router-link>
      <router-link to="/year/2007">2007</router-link>
      <router-link to="/year/2008">2008</router-link>
      <router-link to="/year/2009">2009</router-link>
      <router-link to="/year/2010">2010</router-link>
      <router-link to="/year/2011">2011</router-link>
      <router-link to="/year/2012">2012</router-link>
      <router-link to="/year/2013">2013</router-link>
      <router-link to="/year/2014">2014</router-link>
      <router-link to="/year/2015">2015</router-link>
      <router-link to="/year/2016">2016</router-link>
      <router-link to="/year/2017">2017</router-link>
      <router-link to="/year/2018">2018</router-link>
      <router-link to="/year/2019">2019</router-link>
      <router-link to="/year/2020">2020</router-link>
    </div>

    <div id="nav-years-mobile-top">
      <router-link to="/year/2001">01</router-link>
      <router-link to="/year/2002">02</router-link>
      <router-link to="/year/2003">03</router-link>
      <router-link to="/year/2004">04</router-link>
      <router-link to="/year/2005">05</router-link>
      <router-link to="/year/2006">06</router-link>
      <router-link to="/year/2007">07</router-link>
      <router-link to="/year/2008">08</router-link>
      <router-link to="/year/2009">09</router-link>
      <router-link to="/year/2010">10</router-link>
    </div>
    <div id="nav-years-mobile-bottom">
      <router-link to="/year/2011">11</router-link>
      <router-link to="/year/2012">12</router-link>
      <router-link to="/year/2013">13</router-link>
      <router-link to="/year/2014">14</router-link>
      <router-link to="/year/2015">15</router-link>
      <router-link to="/year/2016">16</router-link>
      <router-link to="/year/2017">17</router-link>
      <router-link to="/year/2018">18</router-link>
      <router-link to="/year/2019">19</router-link>
      <router-link to="/year/2020">20</router-link>
    </div>
    </div>
</template>



<script>

import axios from 'axios';

export default {
  name: 'YearsNav',
   
}

</script>

<style>

#nav-years {
    padding: 3px 0px;
    display: flex;
    flex-wrap:wrap;
    flex-direction: row;
    width: 100%;
    position: fixed;
    top: 50px;
    float: left;
    justify-content: space-around;
    z-index:5;
    background: black;
}

#nav-years a {
    font-weight: bold;
    font-family: 'Teko', sans-serif;
    color: #2c3e50;
    background: black;
    color: white;
    font-size: 26px;
    display: inline-block;
    height: 35px;
    width: 65px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition-duration: 300ms;
    border: 2px solid white;
    text-decoration: none;
}

#nav-years a:hover {
    font-weight: bold;
    color: #fff;
    background: #D3BC8D;
    transform: scale(1.1);
    transition-duration: 300ms;
    border-color: #D3BC8D;
}

#nav-years a.router-link-exact-active {
    color: #000000;
    transform: scale(1.2);
    background: white;
    transition-duration: 300ms;
}

#nav-years-mobile-top {
    display:none;
    padding: 0px;
    display: none;
    flex-wrap:wrap;
    flex-direction: row;
    width: 100%;
    position: fixed;
    top:50px;
    justify-content: space-between;
    z-index:5;
    background-color:black;
    font-family: 'Teko', sans-serif;
    font-weight:400;
}

#nav-years-mobile-bottom {
    display:none;
    padding: 0px;
    display: none;
    flex-wrap:wrap;
    flex-direction: row;
    width: 100%;
    position: fixed;
    float: right;
    bottom:0;
    justify-content: space-between;
    z-index:5;
    background-color:black;
    font-family: 'Teko', sans-serif;
    font-weight:400;
}

#nav-years-mobile-top > a, #nav-years-mobile-bottom > a {
    border: 1px solid #fff;
    color: #fff;
    text-decoration: none;
    font-size: 15px;
    padding: 1px 3px;
    height: 30px;
    display: flex;
    width: 8%;
    flex-wrap: nowrap;
    flex-direction: row;
    margin: 0px;
    justify-content: center;
    align-items: center;
}

#nav-years-mobile-top > a.router-link-exact-active.router-link-active, #nav-years-mobile-bottom > a.router-link-exact-active.router-link-active  {
    background: white;
    color: black;
}

@media (max-width:1366px) {
  #nav-years a {
    height: 35px;
    width: 50px;
    font-size:22px;
  }
}


@media (max-width:1280px) {

    #nav-years a {
    height:30px;
  }

}


@media (max-width:1024px) {
#nav-years {
    bottom: 0;
    height: 92px;
}


  #nav-years a {
    width:90px;
    height:40px;
    margin-bottom:5px;
  }

}

@media (max-width:1023px) {
  #nav-years a {
    width:70px;
    height:40px;
    margin-bottom:5px;
  }

}

@media (max-width:767px) {
#nav-years {
display:none;
}

#nav-years-mobile-top {
    display:flex;
}

#nav-years-mobile-bottom {
    display:flex;
}

}



@media (max-width:420px) {
.share-icon {
   
    width: 32%;
    height: 40px;
    padding: 5px 5px;
    border-radius: 3px;
    font-size: 16px;

  }
}


.horiz-fade-enter {

}

.horiz-fade-enter-active {
  transform: translateX(100px);
  opacity: 0;
}

.horiz-fade-enter-to {
  transition: all .3s ease;
  transform: translateY(0px);
  opacity: 1;
}

.horiz-fade-leave {

}

.horiz-fade-leave-active {
  transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.horiz-fade-leave-to {
  transform: translateX(100px);
  opacity: 0;
}




</style>


// WEBPACK FOOTER //
// src/components/YearsNav.vue